import React from 'react';
import PropTypes from 'prop-types';
// javascript plugin used to create scrollbars on windows
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// @material-ui/core components
import styles from 'assets/jss/Layout';
import Icon from '@material-ui/core/Icon';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import withStyles from '@material-ui/core/styles/withStyles';
// our components
import WithPermission from 'components/User/WithPermission';

/**
 * @description
 * Stateless component that map menu item to NavItem.
 *
 * @param {Object} props - Component props.
 */
const NavItem = ({ item }) => {
  const { t } = useTranslation();

  return (
    <ListItem key={item.name}>
      <NavLink to={item.path} exact>
        <ListItemIcon>
          {typeof icon === 'string' ? <Icon>{item.icon}</Icon> : <item.icon />}
        </ListItemIcon>
        <ListItemText
          primary={t(`common.sidemenu.${item.name}`)}
          primaryTypographyProps={{ fontSize: 10 }}
        />
      </NavLink>
    </ListItem>
  );
};

/**
 * NavItem PropTypes
 * @param item - prop item that correspond a menu item
 */

NavItem.propTypes = {
  item: PropTypes.instanceOf(Object).isRequired,
};

/**
 * @description
 * Stateless component that render menu items.
 *
 * @param {Object} props - Component props.
 */
const Sidebar = props => {
  const { routes, open, classes } = props;
  const links = (
    <List
      className={[classes.sideMenu, open && classes.sideMenuAnimation].join(
        ' ',
      )}
    >
      {routes.map(prop =>
        prop.allowPermissions ? (
          <WithPermission
            key={prop.name}
            allowPermissions={prop.allowPermissions}
          >
            {prop.requiredPermission ? (
              <WithPermission allowPermissions={prop.requiredPermission}>
                {prop.sidebarShow && <NavItem item={prop} />}
              </WithPermission>
            ) : (
              prop.sidebarShow && <NavItem item={prop} />
            )}
          </WithPermission>
        ) : (
          prop.sidebarShow && <NavItem key={prop.name} item={prop} />
        ),
      )}
    </List>
  );
  return <React.Fragment>{links}</React.Fragment>;
};

/**
 * Sidebar PropTypes
 * @param classes - prop styles received from withStyles
 * @param routes - prop all app routes
 * @param open - prop to know if menu is open or not
 */

Sidebar.propTypes = {
  routes: PropTypes.instanceOf(Object).isRequired,
  open: PropTypes.bool.isRequired,
  classes: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(styles)(Sidebar);
